import { ChangeDetectionStrategy, Component, output } from '@angular/core';

import { StaticUrlPipe } from '@app/shared/pipes/static-url.pipe';

@Component({
  selector: 'app-cyber-button',
  templateUrl: './cyber-button.component.html',
  styleUrls: ['./cyber-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StaticUrlPipe],
})
export class CyberButtonComponent {
  readonly buttonClick = output<void>();

  onButtonClick(): void {
    this.buttonClick.emit();
  }
}
